import { getEnv } from 'environment';
import $ from 'jquery';
import { zeroPad } from 'utils';

/*global Septima */

export async function initSeptimaSearch(vdMap) {
    const env = await getEnv();

    // noinspection JSUnusedGlobalSymbols,JSUnresolvedVariable,JSUnresolvedFunction
    const controller = new Septima.Search.Controller([], {
        onError: error => console.warn('Septima Search error', error)
    });

    // noinspection JSUnresolvedVariable,JSUnresolvedFunction
    const view = new Septima.Search.DefaultView({
        input: 'septimaSearchInput',
        controller: controller,
        limit: 18
    });

    // noinspection JSCheckFunctionSignatures,JSUnresolvedFunction,JSUnresolvedVariable
    controller.addSearcher({
        title: 'Viser kun adresser',
        searcher: new Septima.Search.DawaSearcher({
            onSelect: function (res) {
                const searchOption = $("input[name=mapSearchOptions]:checked").val();
                if (searchOption === "zoom") {
                    // noinspection JSUnresolvedVariable
                    if (!res.newquery) {
                        view.blur(true);
                        setTimeout(function () {
                            view.blur(true);
                        }, 100);
                    }
                    mapZoom(res, vdMap);
                }
                // we filter on type to make sure an address with building number is chosen before we call addSection
                else if (searchOption === "add" && res.data.type !== null && res.data.type.toLowerCase() === "feature") {
                    res.data.properties.searchType ="dawa";
                    res.data.properties.wkt = OLUtils.WKT.writeFeature(OLUtils.toFeature(res.data));
                    doAddSection(res.data.properties);
                }
            }
        })
    });

    // noinspection JSCheckFunctionSignatures,JSUnresolvedFunction,JSUnresolvedVariable
    controller.addSearcher({
        title: 'Viser kun veje',
        searcher: new Septima.Search.ClientSearcher({
            singular: 'Vej',
            plural: 'Veje',
            isAsync: true,
            provider: createVejmanSearchProvider(env.searchUrl),
            onSelect: function (res) {
                view.blur(true);
                const searchOption = $("input[name=mapSearchOptions]:checked").val();
                if (searchOption === "zoom") {
                    mapZoom(res, vdMap);
                }
                else if (searchOption === "add") {
                    const p = res.data.feature.properties;
                    p.searchType = "vejman";
                    doAddSection(p);
                }
            }
        })
    });

    const allSearchers = controller.getSearchers();
    const vejmanSearcher = allSearchers.slice(1);

    $('#mainForm_mapSearchOptionszoom').on('change', function () {
        if (this.checked) {
            controller.searchers = allSearchers;
        }
    });
    $('#mainForm_mapSearchOptionsadd').on('change', function () {
        if (this.checked) {
            controller.searchers = vejmanSearcher;
        }
    });
}

function createVejmanSearchProvider(searchUrl) {
    return {
        query: function (query, limit) {
            if (!query) {
                return $.Deferred().resolve(buildVejmanSearchResult([])).promise();
            }

            return $.getJSON(searchUrl + '/roads', {search: query, maxhits: limit})
                .then(
                    function (data) {
                        return buildVejmanSearchResult(data.features);
                    },
                    function (jqXHR, textStatus, error) {
                        return error;
                    }
                );
        }
    };
}

function buildVejmanSearchResult(features) {
    const results = $.map(features, function (/* { geometry, properties: { hit } } */ feature) {
        return {
            title: getVejmanResultDisplayName(feature),
            feature: feature,
            geometry: feature.properties.hit || feature.geometry
        }
    });

    return {
        status: 'ok',
        hits: results.length,
        results: results
    };
}

function getVejmanResultDisplayName(feature) {
    const p = feature.properties;
    return `${p.roadNumber}-${p.roadPart} ${p.displayName} ${formatKmt(p.fromKmt)}-${formatKmt(p.toKmt)}`;
}

function formatKmt(kmt) {
    if (kmt === null || kmt === "")
        return "";

    return `${Math.round(kmt / 10000)}/${zeroPad(kmt % 10000, 4)}`;
}

function doAddSection(data) {
    $('#addSection')
        .val(JSON.stringify(data))
        .prop('disabled', false)
        .closest('form')
        .submit();
}

function mapZoom(data, vdMap) {
    const geometry = data.geometry;
    vdMap.clearHighlights();
    vdMap.highlightGeometry(geometry, true);
    if (!!geometry.type && geometry.type.toLowerCase() === "point") {
        vdMap.map.getView().setZoom(vdMap.map.getView().getZoom() - 4); // -4 gives us zoom level 100m (when type is point)
    }
    const position = $('#map').position();
    scrollTo(position.left, position.top)
}
